import 'what-input';
import './lib/foundation-explicit-pieces';


(function ($, Drupal , once){
  // Init Foundation
  Foundation.addToJquery($);
  $(document).foundation();
  console.log('test');


  Drupal.behaviors.exampleBehavior = {
    attach: function (context, settings) {

      // alert("I'm alive!");
      //console.log('xdxd');
    }
  };



  /**
   * Use this behavior as a template for custom Javascript.
   */
  Drupal.behaviors.slides = {
    attach: function (context, settings) {
      $(once('ifImagesSlider', '.field-name-field-images.swiper-container', context)).each(function (){
        var slides = new Swiper (this, {
          autoplay: true,
          loop: true,
          effect: 'fade',
          pagination: {
            el: ".swiper-pagination",
            type: "fraction",
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        });
      });

      $(once('ifInterestingLinksSlider', '.field-name-field-interesting-links.swiper-container', context)).each(function (){
        var slides = new Swiper (this, {
          autoplay: false,
          loop: false,
          effect: 'slide',
          slidesPerView: 1,
          pagination: {
            el: ".swiper-pagination",
            type: "progressbar",
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
              spaceBetween: 40,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 50,
            }
          }
        });
      });

      $(once('ifNewsItemsSlider', '.field-name-field-newsitems.swiper-container', context)).each(function (){
        var slides = new Swiper (this, {
          autoplay: false,
          loop: false,
          effect: 'slide',
          slidesPerView: 1,
          spaceBetween: 40,
          pagination: {
            el: ".swiper-pagination",
            type: "progressbar",
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },

          breakpoints: {
            640: {
              slidesPerView: 1.5,
              spaceBetween: 40,
            },
            854: {
              slidesPerView: 1.6,
              spaceBetween: 40,
            },
            1260: {
              slidesPerView: 2.2,
              spaceBetween: 50,
            }
          }
        });
      });

      $(once('ifEmployeesSlider', '.field-name-field-employees.swiper-container', context)).each(function (){
        var slides = new Swiper (this, {
          autoplay: false,
          loop: false,
          effect: 'slide',
          slidesPerView: 1,
          pagination: {
            el: ".swiper-pagination",
            type: "progressbar",
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
              spaceBetween: 40,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 50,
            }
          }
        });
      });

      $(once('ifEmployeesDoubleSlider', '.field-name-field-employees-2.swiper-container', context)).each(function (){
        var slides = new Swiper (this, {
          autoplay: false,
          loop: false,
          effect: 'slide',
          slidesPerView: 1,
          spaceBetween: 40,
          pagination: {
            el: ".swiper-pagination",
            type: "progressbar",
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },

          breakpoints: {
            640: {
              slidesPerView: 1.5,
              spaceBetween: 40,
            },
            854: {
              slidesPerView: 1.6,
              spaceBetween: 40,
            },
            1260: {
              slidesPerView: 2.2,
              spaceBetween: 50,
            }
          }
        });
      });

    }
  };

  Drupal.behaviors.masonry = {
    attach: function (context, settings) {
        $('.secnav .grid').masonry({
          itemSelector: '.grid-item',
          gutter: 30,
          fitWidth: false
        });

      $('nav.secnav li a').filter(function(){
        return this.href === location.href;
      }).addClass('active-link');

      $('nav.secnav li.secnavlink span.innerlink').filter(function(){

        var linkcheck = $(this).text().toLowerCase();
        var pathname = window.location.pathname.substring(1);
        return linkcheck === pathname;
      }).addClass('active-link');

    }
  };

  Drupal.behaviors.mobile_dropdown = {
    attach: function (context, settings) {
      $( ".toggler" ).on( "click touchstart", function(e) {
        e.preventDefault();
        $(this).parent('.secnavlink').toggleClass('active');
      });
    }
  };


 Drupal.behaviors.anchorsActive = {
    attach: function (context, settings) {
      $(".anchorLink").on('click touchstart', function(e) {
        $(".anchorLink").removeClass('active');
        $(this).addClass('active');
      });
    }
  };

  Drupal.behaviors.textResizeCustom = {
    attach: function (context, settings) {
      $(".changer").on('click touchstart', function(e) {
        setTimeout(function () {
          var height = $("#sliding-popup").outerHeight();
          $("#sliding-popup").css({bottom: -2 * height});
        })
      });
    }
  };

  //anchors fixed scroll

  var heightOfSidemenu;
  var heightOfSidemenu2;

  Drupal.behaviors.anchors_fixed_scroll = {
    attach: function (context, settings) {

      if ( $(".paragraph--type--anchors .left-wrapper").length == 1) {
        heightOfSidemenu = $(".paragraph--type--anchors .left-wrapper .field-paragraph--field-labels").height() + 90 + 45;
        heightOfSidemenu2 = $(".paragraph--type--anchors .left-wrapper .field-paragraph--field-labels").height();

        $(window).on('scroll',function(e){
          if(checkWidth()) {
            fixedScroll();
            e.preventDefault();
          }
        });
      }

    }
  };

  function checkWidth() {
    var $window = $(window);
    var windowsize = $window.width();
    if (windowsize > 768) {
      return true;
    }
  }

  function fixedScroll(){
    var scrolled = $(window).scrollTop();
    var offsetLeft = $(".paragraph--type--anchors .left-wrapper").offset();
    var offsetFooter = $(".paragraph--type--anchors .menu-stop").offset().top - 50;
    var heightshizzle = $(".paragraph--type--anchors .right-wrapper .field-paragraph--field-anchors").height();

    // console.log(scrolled);

    if(scrolled >= offsetLeft.top - 100 && scrolled <= offsetFooter - heightOfSidemenu){
      $(".paragraph--type--anchors .left-wrapper .field-paragraph--field-labels").addClass("fixed");
      $(".paragraph--type--anchors .left-wrapper .field-paragraph--field-labels").css("top", "50px");
      $(".paragraph--type--anchors .left-wrapper .field-paragraph--field-labels").css("width", $(".paragraph--type--anchors .left-wrapper").width());
      $(".paragraph--type--anchors .left-wrapper .field-paragraph--field-labels").removeClass("relative");
      $(".paragraph--type--anchors .left-wrapper").css("align-items", "flex-start");

    }else{
      if(scrolled >= offsetFooter - heightOfSidemenu){
        $(".paragraph--type--anchors .left-wrapper .field-paragraph--field-labels").removeClass("fixed").addClass("relative");
        $(".paragraph--type--anchors .left-wrapper .field-paragraph--field-labels").css("top", heightshizzle - heightOfSidemenu2 - 20);
        $(".paragraph--type--anchors .left-wrapper").css("align-items", "flex-end");
      }

      $(".paragraph--type--anchors .left-wrapper .field-paragraph--field-labels").removeClass("fixed");
    }

  }


    //fix id's from the anchors
    //dirty sanchez

  if ( $(".paragraph--type--anchors .left-wrapper").length > 1) {


    $('.paragraph--type--anchors .anchorLink').each(function(){
      var paragraph_id = $(this).parent().parent().parent().parent().parent().parent().attr('id');
      var link = $(this).attr('href');
      var link = link.substring(1);
      var newlink = link.replace(link, '#' + paragraph_id + link);
      $(this).attr('href', newlink);
    });

    $('.paragraph--type--anchors .anchorTarget').each(function(){
      var paragraph_id = $(this).parent().parent().parent().parent().parent().parent().parent().attr('id');
      var id = $(this).attr('id');
      // var newlink = link.replace(link, '#' + paragraph_id + link);
      // console.log(newlink);
      $(this).attr('id', paragraph_id + id);
    });
  }

    /**
   * Use this behavior as a template for custom Javascript.
   */
  Drupal.behaviors.smoothScroll = {
    attach: function (context, settings) {
      $(once('scroll-to', '.scrollTo', context)).click(function (e){
        var anchor = $(this).attr('href');
        var arr = anchor.split(' ');
        anchor = arr[0];

        if($(anchor).offset().top != 'undefined') {
          var offset = $(anchor).offset().top - 50;
          e.preventDefault();
          $('html,body').animate({
            scrollTop: offset
          }, 500);
        }
      });
    }
  };


  /**
   * Dirty Sanches
   * change titel of certain pages
   */
  Drupal.behaviors.textChange = {
    attach: function (context, settings) {
      if ($(".node-211 .employees-view-block .employees-inner-wrapper .title").length > 1) {
        //change 'hoofdverpleegkundige' to 'diensthoofd' on certain pages
        $(".node-211 .employees-view-block .employees-inner-wrapper .title").first().html('Diensthoofd');
      }
    }
  };


  //toggle filters on appointment booker
  Drupal.behaviors.toggleButton = {
    attach: function (context, settings) {

      $(document).on('click', '.toggle-button',  function(event) {
        event.preventDefault();
        $("#sidebar-dropdown").toggleClass('open');
      });

      // $(".toggle-button").on('click', function(e) {
      //   e.preventDefault();
      //   $("#sidebar-dropdown").toggleClass('open');
      // });
    }
  };



})(jQuery, Drupal, once);
